var _defs, _g, _path, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g4, _g5, _path12, _path13, _g6, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g7, _path30, _path31, _g8, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 1000,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "8f928bfbe9"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0f34e7ecfe"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "904062ca45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.441406 1 L 377.71875 1 L 377.71875 216 L 0.441406 216 Z M 0.441406 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3e06400c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 222.394531 4.195312 C 216.011719 0.554688 208.1875 0.554688 201.804688 4.195312 L 5.898438 115.871094 C -1.101562 119.863281 -1.101562 129.953125 5.898438 133.941406 L 144.453125 212.925781 C 150.835938 216.566406 158.664062 216.566406 165.042969 212.925781 L 261.710938 157.820312 C 271.285156 155.902344 280.292969 152.921875 288.117188 148.878906 C 288.269531 148.957031 288.429688 149.023438 288.59375 149.078125 L 364.554688 192.683594 C 365.832031 193.84375 367.996094 193.839844 370.457031 192.421875 C 374.382812 190.160156 377.566406 185.136719 377.566406 181.210938 C 377.566406 179.179688 376.714844 177.835938 375.347656 177.328125 L 304.496094 136.65625 C 306.070312 134.871094 307.390625 133.035156 308.464844 131.167969 L 360.949219 101.25 C 367.949219 97.257812 367.949219 87.167969 360.949219 83.179688 Z M 222.394531 4.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 235.045477,
    gradientTransform: "matrix(0.475977, 0, 0, 0.475977, -103.589396, -124.192034)",
    y1: 233.515177,
    x2: 1029.513323,
    gradientUnits: "userSpaceOnUse",
    y2: 682.510269,
    id: "f9bdb36e62"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.244127
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.658203%, 99.658203%, 99.658203%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.317932%, 99.317932%, 99.317932%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.480225%, 98.480225%, 98.480225%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.644043%, 97.644043%, 97.644043%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.807861%, 96.807861%, 96.807861%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.97168%, 95.97168%, 95.97168%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.133972%, 95.133972%, 95.133972%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.297791%, 94.297791%, 94.297791%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.461609%, 93.461609%, 93.461609%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.625427%, 92.625427%, 92.625427%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.78772%, 91.78772%, 91.78772%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.951538%, 90.951538%, 90.951538%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.113831%, 90.113831%, 90.113831%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.277649%, 89.277649%, 89.277649%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.441467%, 88.441467%, 88.441467%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.605286%, 87.605286%, 87.605286%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.767578%, 86.767578%, 86.767578%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.931396%, 85.931396%, 85.931396%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.093689%, 85.093689%, 85.093689%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.257507%, 84.257507%, 84.257507%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.421326%, 83.421326%, 83.421326%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.585144%, 82.585144%, 82.585144%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.747437%, 81.747437%, 81.747437%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.911255%, 80.911255%, 80.911255%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.075073%, 80.075073%, 80.075073%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.238892%, 79.238892%, 79.238892%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.401184%, 78.401184%, 78.401184%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.565002%, 77.565002%, 77.565002%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.727295%, 76.727295%, 76.727295%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.891113%, 75.891113%, 75.891113%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.054932%, 75.054932%, 75.054932%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.21875%, 74.21875%, 74.21875%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.381042%, 73.381042%, 73.381042%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.544861%, 72.544861%, 72.544861%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.707153%, 71.707153%, 71.707153%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.870972%, 70.870972%, 70.870972%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.03479%, 70.03479%, 70.03479%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.198608%, 69.198608%, 69.198608%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.360901%, 68.360901%, 68.360901%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.524719%, 67.524719%, 67.524719%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.688538%, 66.688538%, 66.688538%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.852356%, 65.852356%, 65.852356%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.014648%, 65.014648%, 65.014648%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.178467%, 64.178467%, 64.178467%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.340759%, 63.340759%, 63.340759%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.504578%, 62.504578%, 62.504578%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.668396%, 61.668396%, 61.668396%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.832214%, 60.832214%, 60.832214%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.994507%, 59.994507%, 59.994507%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.158325%, 59.158325%, 59.158325%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.320618%, 58.320618%, 58.320618%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.484436%, 57.484436%, 57.484436%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.648254%, 56.648254%, 56.648254%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.812073%, 55.812073%, 55.812073%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.974365%, 54.974365%, 54.974365%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.138184%, 54.138184%, 54.138184%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.300476%, 53.300476%, 53.300476%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.464294%, 52.464294%, 52.464294%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.628113%, 51.628113%, 51.628113%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.791931%, 50.791931%, 50.791931%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.954224%, 49.954224%, 49.954224%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.118042%, 49.118042%, 49.118042%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.28186%, 48.28186%, 48.28186%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.445679%, 47.445679%, 47.445679%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.607971%, 46.607971%, 46.607971%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.77179%, 45.77179%, 45.77179%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.934082%, 44.934082%, 44.934082%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.0979%, 44.0979%, 44.0979%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.261719%, 43.261719%, 43.261719%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.425537%, 42.425537%, 42.425537%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.58783%, 41.58783%, 41.58783%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.751648%, 40.751648%, 40.751648%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.91394%, 39.91394%, 39.91394%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.077759%, 39.077759%, 39.077759%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.241577%, 38.241577%, 38.241577%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.405396%, 37.405396%, 37.405396%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.567688%, 36.567688%, 36.567688%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.731506%, 35.731506%, 35.731506%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.895325%, 34.895325%, 34.895325%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.059143%, 34.059143%, 34.059143%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.221436%, 33.221436%, 33.221436%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.385254%, 32.385254%, 32.385254%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.547546%, 31.547546%, 31.547546%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.711365%, 30.711365%, 30.711365%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.875183%, 29.875183%, 29.875183%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.039001%, 29.039001%, 29.039001%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.201294%, 28.201294%, 28.201294%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.365112%, 27.365112%, 27.365112%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.527405%, 26.527405%, 26.527405%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.691223%, 25.691223%, 25.691223%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.855042%, 24.855042%, 24.855042%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.01886%, 24.01886%, 24.01886%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.181152%, 23.181152%, 23.181152%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.344971%, 22.344971%, 22.344971%)",
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.507263%, 21.507263%, 21.507263%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.671082%, 20.671082%, 20.671082%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.8349%, 19.8349%, 19.8349%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 18.998718%, 18.998718%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.161011%, 18.161011%, 18.161011%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.324829%, 17.324829%, 17.324829%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.488647%, 16.488647%, 16.488647%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.652466%, 15.652466%, 15.652466%)",
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.814758%, 14.814758%, 14.814758%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.978577%, 13.978577%, 13.978577%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.140869%, 13.140869%, 13.140869%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.304688%, 12.304688%, 12.304688%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.468506%, 11.468506%, 11.468506%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.632324%, 10.632324%, 10.632324%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.794617%, 9.794617%, 9.794617%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.958435%, 8.958435%, 8.958435%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.120728%, 8.120728%, 8.120728%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.284546%, 7.284546%, 7.284546%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.448364%, 6.448364%, 6.448364%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.612183%, 5.612183%, 5.612183%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.774475%, 4.774475%, 4.774475%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.938293%, 3.938293%, 3.938293%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.102112%, 3.102112%, 3.102112%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.26593%, 2.26593%, 2.26593%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.428223%, 1.428223%, 1.428223%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.592041%, 0.592041%, 0.592041%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.296021%, 0.296021%, 0.296021%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46f9d50ec4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 378,
    y: 0,
    height: 217
  })), /*#__PURE__*/React.createElement("mask", {
    id: "93cf91a111"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e24d70c70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.359375 0.28125 L 212 0.28125 L 212 215.320312 L 0.359375 215.320312 Z M 0.359375 0.28125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "697a4f39e0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 213,
    y: 0,
    height: 216
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0ab5978974"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "922b96d0df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0390625 1 L 66 1 L 66 88.640625 L 0.0390625 88.640625 Z M 0.0390625 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8ff116ae0a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 67,
    y: 0,
    height: 89
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c4e917e242"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f9ac07a1ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.878906 0.480469 L 21 0.480469 L 21 29.761719 L 0.878906 29.761719 Z M 0.878906 0.480469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "95fca6c7f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 22,
    y: 0,
    height: 30
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2295887ec0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b99db02950"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.71875 0.160156 L 11 0.160156 L 11 18.398438 L 0.71875 18.398438 Z M 0.71875 0.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "28b6ee2132"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 12,
    y: 0,
    height: 19
  })), /*#__PURE__*/React.createElement("mask", {
    id: "22e01b5be1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb7757ab05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.199219 0.257812 L 106 0.257812 L 106 65.535156 L 0.199219 65.535156 Z M 0.199219 0.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8de25571e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.050781 2.296875 C 16.574219 0.257812 20.90625 0.257812 24.425781 2.296875 L 103.058594 47.757812 C 106.890625 49.972656 106.890625 55.550781 103.058594 57.765625 L 93.148438 63.496094 C 89.625 65.535156 85.296875 65.535156 81.773438 63.496094 L 3.140625 18.035156 C -0.691406 15.820312 -0.691406 10.242188 3.140625 8.023438 Z M 13.050781 2.296875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "8a368cd88a"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.00000000000017053, 0.000000000000113687)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 107,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAABDCAYAAACbQPtXAAAABmJLR0QA/wD/AP+gvaeTAAAE1klEQVR4nO3by48UVRTH8c/MNG8RRIJBRNBBFCPiMy6EEBe6MC7cykYTN/5bJi41ceFCV8RnjCYmovgARCMoREDAAQTm5eJUOcww3dOPqq7bPfVLKj11Mt0zfb91Hvfce6lVq1atWrVq1aq1fDXSwj6C2ex+tsnv1eqjFsIaxcrs59kF14waXqW6Fdbq7MqhLAaqhlehcljrsqtTUDW8PqqRXXcpBlQNr0Q1sB4rFAurhleCGliTvZbhVe3YqOG1pQbGhGdVAaqG14EamDIfVpWgangt1MBFbFM9lBreEhoTntXARjEpLuoaKdmWTzuadWGGTo3s9ZQYgNzDqvSgXt6Xe95QauFTuRHjipsgV2GbMqTQFgshI7hHQEu58Ghlm8EkpnsbnrTUKt6PYSd2ZPdVA+jWy24aEk9rJzmvwy7hbd3kkRTg3cT17OeBVSeV1GY8qj/5rIzPn8G/uNHBd05KnZa9oyI0PmR+iyoVD2oH/BSuiJw2UOp2jrISD+MBtw9WSqBa2W5gwgAVIb1OKDficdwtDQCd2mZwVUCb7XEsSldRs/978QTWSrfIaGWbxj8iPCarIls1Y9gtipAx5Qxu2fBu4G+JFiFl9NXWCi/bKR0P6vR9V3FBFCPJqMwm6GY8k72mEOo6tc0IL7uY3VeufnSsd+FprFI9gG5skzgnclql6tfyQkNUjXvFXK1qAN3YruKs6IRUon6vBW3As2J+lmqRsZTtooDW93xW1cLdNjwvtsBVCaHb900JYOez+76oylXWUezBcwYvn+X313Ealwsem0WVwpL4agHsMXOHIVKB0q7tMn4XjeLSlAKsXJtwEPdLA0CnthkRGk8rqd+YEqxc43gBdyo+1/TDNim87Gx2X5hShEW0q57EfsXuFu4nvAmcVGA+SxVWrjtwQMzRSMuD2n3fOZxQwPwsdVi5tuIlt2+VSwleK9u0CI2/6SGfDQos4n/dgxfN5bPUoCxlu45jONPtAAyaVohctt9c6yo1KEvZLuHH7LVtDSKsXBuEl+3T+0BWBe8UftLm+tkgw8o1jlewRf8HvIjPmhIFyPHM1lTDAIv4Hk/hZbFVLoVQ16ltAkfxZ7MvOdb18KSnM/hafKcdYn7Wz1MtvdpWYbvYfHTJIqFxmGARIeU4vhc7iLdID8pStvV4UGz3u+CW0DgsYbCZ9uJV87fKpVZktLJdxiciRA6dZy3UX/hC9Ovyp7XZ053iQcI1oiHwC2aGHRbxlJ7E5yIv7BQPaZlhrUjIa8TSy/nlACvXpKi2fhCJfLN08tRS1wocW06wcl0SofGcuVOeKYBqZRvDt8sRVq7T+Fh43G6Rz6qG0sx2DUeWMyyiA34cX4qwuF25+adb2684sdxh5bqGr/CzqBo3KS//dAP9I1ypYc3XeRwW85vdohKrOiR+Jib5Qz/P6kazotQ/LEr9/JRnv0FN40MBC8PfwShCW/GG2K/fr07GUbwvDkb8rxpW+9qHN0URUla76hTeE0smt6mG1ZkaYhnmNXEOrShYE/hAhN6ma1o1rO60HofEoueI7kFNibneu9o4IlvD6k3jeEts/e4U1BG8LSbnbamGVYwO4nXcZ2lQJ/EOvun0j9SwitOoOHt2AI+Ixc9V4hDeH2I306f4TkCrVatWEvoPo4pQbsEe6tkAAAAASUVORK5CYII=",
    height: 67,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 693.854687,
    gradientTransform: "matrix(0.475977, 0, 0, 0.475977, -319.589396, -89.192034)",
    y1: 330.533608,
    x2: 738.863623,
    gradientUnits: "userSpaceOnUse",
    y2: 149.338537,
    id: "377be7b923"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.827576%, 99.827576%, 99.827576%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.974609%, 98.974609%, 98.974609%)",
    offset: 0.0976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.295593%, 98.295593%, 98.295593%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.616577%, 97.616577%, 97.616577%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.937561%, 96.937561%, 96.937561%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.258545%, 96.258545%, 96.258545%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.579529%, 95.579529%, 95.579529%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.900513%, 94.900513%, 94.900513%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.221497%, 94.221497%, 94.221497%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.54248%, 93.54248%, 93.54248%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.863464%, 92.863464%, 92.863464%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.184448%, 92.184448%, 92.184448%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.505432%, 91.505432%, 91.505432%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.826416%, 90.826416%, 90.826416%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.1474%, 90.1474%, 90.1474%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.468384%, 89.468384%, 89.468384%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.789368%, 88.789368%, 88.789368%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.110352%, 88.110352%, 88.110352%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.431335%, 87.431335%, 87.431335%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.752319%, 86.752319%, 86.752319%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.073303%, 86.073303%, 86.073303%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.394287%, 85.394287%, 85.394287%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.715271%, 84.715271%, 84.715271%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.036255%, 84.036255%, 84.036255%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.357239%, 83.357239%, 83.357239%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.678223%, 82.678223%, 82.678223%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.999207%, 81.999207%, 81.999207%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.32019%, 81.32019%, 81.32019%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.641174%, 80.641174%, 80.641174%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.962158%, 79.962158%, 79.962158%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.283142%, 79.283142%, 79.283142%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.604126%, 78.604126%, 78.604126%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.92511%, 77.92511%, 77.92511%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.246094%, 77.246094%, 77.246094%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.567078%, 76.567078%, 76.567078%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.888062%, 75.888062%, 75.888062%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.209045%, 75.209045%, 75.209045%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.530029%, 74.530029%, 74.530029%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.851013%, 73.851013%, 73.851013%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.171997%, 73.171997%, 73.171997%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.492981%, 72.492981%, 72.492981%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.813965%, 71.813965%, 71.813965%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.134949%, 71.134949%, 71.134949%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.455933%, 70.455933%, 70.455933%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.776917%, 69.776917%, 69.776917%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.0979%, 69.0979%, 69.0979%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.418884%, 68.418884%, 68.418884%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.739868%, 67.739868%, 67.739868%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.060852%, 67.060852%, 67.060852%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.381836%, 66.381836%, 66.381836%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.70282%, 65.70282%, 65.70282%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.023804%, 65.023804%, 65.023804%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.344788%, 64.344788%, 64.344788%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.665771%, 63.665771%, 63.665771%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.986755%, 62.986755%, 62.986755%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.307739%, 62.307739%, 62.307739%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.628723%, 61.628723%, 61.628723%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.949707%, 60.949707%, 60.949707%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.270691%, 60.270691%, 60.270691%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.591675%, 59.591675%, 59.591675%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.912659%, 58.912659%, 58.912659%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.233643%, 58.233643%, 58.233643%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.554626%, 57.554626%, 57.554626%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.87561%, 56.87561%, 56.87561%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.196594%, 56.196594%, 56.196594%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.517578%, 55.517578%, 55.517578%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.838562%, 54.838562%, 54.838562%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.159546%, 54.159546%, 54.159546%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.48053%, 53.48053%, 53.48053%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.801514%, 52.801514%, 52.801514%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.122498%, 52.122498%, 52.122498%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.443481%, 51.443481%, 51.443481%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.764465%, 50.764465%, 50.764465%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.085449%, 50.085449%, 50.085449%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.406433%, 49.406433%, 49.406433%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.727417%, 48.727417%, 48.727417%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.048401%, 48.048401%, 48.048401%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.367859%, 47.367859%, 47.367859%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.688843%, 46.688843%, 46.688843%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.009827%, 46.009827%, 46.009827%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.330811%, 45.330811%, 45.330811%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.651794%, 44.651794%, 44.651794%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.972778%, 43.972778%, 43.972778%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.293762%, 43.293762%, 43.293762%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.614746%, 42.614746%, 42.614746%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.93573%, 41.93573%, 41.93573%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.256714%, 41.256714%, 41.256714%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.577698%, 40.577698%, 40.577698%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.898682%, 39.898682%, 39.898682%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.219666%, 39.219666%, 39.219666%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.540649%, 38.540649%, 38.540649%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.861633%, 37.861633%, 37.861633%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.182617%, 37.182617%, 37.182617%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.503601%, 36.503601%, 36.503601%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.824585%, 35.824585%, 35.824585%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.145569%, 35.145569%, 35.145569%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.466553%, 34.466553%, 34.466553%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.787537%, 33.787537%, 33.787537%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.108521%, 33.108521%, 33.108521%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.429504%, 32.429504%, 32.429504%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.750488%, 31.750488%, 31.750488%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.071472%, 31.071472%, 31.071472%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.392456%, 30.392456%, 30.392456%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.71344%, 29.71344%, 29.71344%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.034424%, 29.034424%, 29.034424%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.355408%, 28.355408%, 28.355408%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.676392%, 27.676392%, 27.676392%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.997375%, 26.997375%, 26.997375%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.318359%, 26.318359%, 26.318359%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.639343%, 25.639343%, 25.639343%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.960327%, 24.960327%, 24.960327%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.281311%, 24.281311%, 24.281311%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.602295%, 23.602295%, 23.602295%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.923279%, 22.923279%, 22.923279%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.244263%, 22.244263%, 22.244263%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.565247%, 21.565247%, 21.565247%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.88623%, 20.88623%, 20.88623%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.207214%, 20.207214%, 20.207214%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.528198%, 19.528198%, 19.528198%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.849182%, 18.849182%, 18.849182%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.170166%, 18.170166%, 18.170166%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.49115%, 17.49115%, 17.49115%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.812134%, 16.812134%, 16.812134%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.133118%, 16.133118%, 16.133118%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.454102%, 15.454102%, 15.454102%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.775085%, 14.775085%, 14.775085%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.096069%, 14.096069%, 14.096069%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.417053%, 13.417053%, 13.417053%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.738037%, 12.738037%, 12.738037%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.059021%, 12.059021%, 12.059021%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.380005%, 11.380005%, 11.380005%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.700989%, 10.700989%, 10.700989%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.021973%, 10.021973%, 10.021973%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.342957%, 9.342957%, 9.342957%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.66394%, 8.66394%, 8.66394%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.984924%, 7.984924%, 7.984924%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.305908%, 7.305908%, 7.305908%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.626892%, 6.626892%, 6.626892%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.947876%, 5.947876%, 5.947876%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.26886%, 5.26886%, 5.26886%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.589844%, 4.589844%, 4.589844%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.910828%, 3.910828%, 3.910828%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.231812%, 3.231812%, 3.231812%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.552795%, 2.552795%, 2.552795%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.873779%, 1.873779%, 1.873779%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.194763%, 1.194763%, 1.194763%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.515747%, 0.515747%, 0.515747%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.257874%, 0.257874%, 0.257874%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.712877
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "957e55583f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 107,
    y: 0,
    height: 66
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e4b02946d9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "52ff159287"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.640625 1 L 154.960938 1 L 154.960938 84.921875 L 0.640625 84.921875 Z M 0.640625 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 2.009808e+53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132.351562 72.527344 C 162.464844 56.269531 162.464844 29.902344 132.351562 13.644531 C 102.242188 -2.617188 53.417969 -2.617188 23.304688 13.644531 C -6.804688 29.902344 -6.804688 56.269531 23.304688 72.527344 C 53.417969 88.789062 102.242188 88.789062 132.351562 72.527344 Z M 122.175781 65.257812 C 146.667969 53.011719 146.667969 33.160156 122.175781 20.914062 C 97.683594 8.667969 57.976562 8.667969 33.484375 20.914062 C 8.992188 33.160156 8.992188 53.011719 33.484375 65.257812 C 57.976562 77.503906 97.683594 77.503906 122.175781 65.257812 Z M 122.175781 65.257812 ",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a715dc7002"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.000000000000227374, 1)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 156,
    xlinkHref: "data:image/png;base64,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",
    height: 85,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 582.31852,
    gradientTransform: "matrix(0.475977, 0, 0, 0.475977, -260.589396, -164.192034)",
    y1: 530.757515,
    x2: 634.481644,
    gradientUnits: "userSpaceOnUse",
    y2: 294.269942,
    id: "6e8bb29258"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.526978%, 99.526978%, 99.526978%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.055481%, 99.055481%, 99.055481%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.379517%, 98.379517%, 98.379517%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.705078%, 97.705078%, 97.705078%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.029114%, 97.029114%, 97.029114%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.353149%, 96.353149%, 96.353149%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.677185%, 95.677185%, 95.677185%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.002747%, 95.002747%, 95.002747%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.326782%, 94.326782%, 94.326782%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.652344%, 93.652344%, 93.652344%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.976379%, 92.976379%, 92.976379%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.300415%, 92.300415%, 92.300415%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.624451%, 91.624451%, 91.624451%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.950012%, 90.950012%, 90.950012%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.274048%, 90.274048%, 90.274048%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.599609%, 89.599609%, 89.599609%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.923645%, 88.923645%, 88.923645%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.247681%, 88.247681%, 88.247681%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.571716%, 87.571716%, 87.571716%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.897278%, 86.897278%, 86.897278%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.221313%, 86.221313%, 86.221313%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.546875%, 85.546875%, 85.546875%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.870911%, 84.870911%, 84.870911%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.196472%, 84.196472%, 84.196472%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.520508%, 83.520508%, 83.520508%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.844543%, 82.844543%, 82.844543%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.168579%, 82.168579%, 82.168579%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.494141%, 81.494141%, 81.494141%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.818176%, 80.818176%, 80.818176%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.143738%, 80.143738%, 80.143738%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.467773%, 79.467773%, 79.467773%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.791809%, 78.791809%, 78.791809%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.115845%, 78.115845%, 78.115845%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.441406%, 77.441406%, 77.441406%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.765442%, 76.765442%, 76.765442%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.091003%, 76.091003%, 76.091003%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.415039%, 75.415039%, 75.415039%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.740601%, 74.740601%, 74.740601%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.064636%, 74.064636%, 74.064636%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.388672%, 73.388672%, 73.388672%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.712708%, 72.712708%, 72.712708%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.038269%, 72.038269%, 72.038269%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.362305%, 71.362305%, 71.362305%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.687866%, 70.687866%, 70.687866%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.011902%, 70.011902%, 70.011902%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.335938%, 69.335938%, 69.335938%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.659973%, 68.659973%, 68.659973%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.985535%, 67.985535%, 67.985535%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.30957%, 67.30957%, 67.30957%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.635132%, 66.635132%, 66.635132%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.959167%, 65.959167%, 65.959167%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.283203%, 65.283203%, 65.283203%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.607239%, 64.607239%, 64.607239%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.9328%, 63.9328%, 63.9328%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.256836%, 63.256836%, 63.256836%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.582397%, 62.582397%, 62.582397%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.906433%, 61.906433%, 61.906433%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.231995%, 61.231995%, 61.231995%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.55603%, 60.55603%, 60.55603%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.880066%, 59.880066%, 59.880066%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.204102%, 59.204102%, 59.204102%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.529663%, 58.529663%, 58.529663%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.853699%, 57.853699%, 57.853699%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.17926%, 57.17926%, 57.17926%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.503296%, 56.503296%, 56.503296%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.827332%, 55.827332%, 55.827332%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.151367%, 55.151367%, 55.151367%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.476929%, 54.476929%, 54.476929%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.800964%, 53.800964%, 53.800964%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.126526%, 53.126526%, 53.126526%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.450562%, 52.450562%, 52.450562%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.776123%, 51.776123%, 51.776123%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.100159%, 51.100159%, 51.100159%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.424194%, 50.424194%, 50.424194%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.74823%, 49.74823%, 49.74823%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.073792%, 49.073792%, 49.073792%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.397827%, 48.397827%, 48.397827%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.723389%, 47.723389%, 47.723389%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.047424%, 47.047424%, 47.047424%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.37146%, 46.37146%, 46.37146%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.695496%, 45.695496%, 45.695496%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.021057%, 45.021057%, 45.021057%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.345093%, 44.345093%, 44.345093%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.670654%, 43.670654%, 43.670654%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.99469%, 42.99469%, 42.99469%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.318726%, 42.318726%, 42.318726%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.642761%, 41.642761%, 41.642761%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.968323%, 40.968323%, 40.968323%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.292358%, 40.292358%, 40.292358%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.61792%, 39.61792%, 39.61792%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.941956%, 38.941956%, 38.941956%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.267517%, 38.267517%, 38.267517%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.591553%, 37.591553%, 37.591553%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.915588%, 36.915588%, 36.915588%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.239624%, 36.239624%, 36.239624%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.565186%, 35.565186%, 35.565186%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.889221%, 34.889221%, 34.889221%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.214783%, 34.214783%, 34.214783%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.538818%, 33.538818%, 33.538818%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.862854%, 32.862854%, 32.862854%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.18689%, 32.18689%, 32.18689%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.512451%, 31.512451%, 31.512451%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.836487%, 30.836487%, 30.836487%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.162048%, 30.162048%, 30.162048%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.486084%, 29.486084%, 29.486084%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.811646%, 28.811646%, 28.811646%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.135681%, 28.135681%, 28.135681%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.459717%, 27.459717%, 27.459717%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.783752%, 26.783752%, 26.783752%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.109314%, 26.109314%, 26.109314%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.43335%, 25.43335%, 25.43335%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.758911%, 24.758911%, 24.758911%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.082947%, 24.082947%, 24.082947%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.406982%, 23.406982%, 23.406982%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.731018%, 22.731018%, 22.731018%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.05658%, 22.05658%, 22.05658%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.380615%, 21.380615%, 21.380615%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.706177%, 20.706177%, 20.706177%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.030212%, 20.030212%, 20.030212%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.354248%, 19.354248%, 19.354248%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.678284%, 18.678284%, 18.678284%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.003845%, 18.003845%, 18.003845%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.327881%, 17.327881%, 17.327881%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.653442%, 16.653442%, 16.653442%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.977478%, 15.977478%, 15.977478%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.30304%, 15.30304%, 15.30304%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.627075%, 14.627075%, 14.627075%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.951111%, 13.951111%, 13.951111%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.275146%, 13.275146%, 13.275146%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.600708%, 12.600708%, 12.600708%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.924744%, 11.924744%, 11.924744%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.250305%, 11.250305%, 11.250305%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.574341%, 10.574341%, 10.574341%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.898376%, 9.898376%, 9.898376%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.222412%, 9.222412%, 9.222412%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.547974%, 8.547974%, 8.547974%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.872009%, 7.872009%, 7.872009%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.197571%, 7.197571%, 7.197571%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.521606%, 6.521606%, 6.521606%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.847168%, 5.847168%, 5.847168%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.171204%, 5.171204%, 5.171204%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.495239%, 4.495239%, 4.495239%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.819275%, 3.819275%, 3.819275%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.144836%, 3.144836%, 3.144836%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.468872%, 2.468872%, 2.468872%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.794434%, 1.794434%, 1.794434%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.118469%, 1.118469%, 1.118469%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.442505%, 0.442505%, 0.442505%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.221252%, 0.221252%, 0.221252%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.711629
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 0%, 0%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dc0605888"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 155,
    y: 0,
    height: 85
  })), /*#__PURE__*/React.createElement("mask", {
    id: "7c16a05e9b"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8f928bfbe9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#000000",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "1444e7b7f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0390625 0 L 90.28125 0 L 90.28125 60.71875 L 0.0390625 60.71875 Z M 0.0390625 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5692a8aa6b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 91,
    y: 0,
    height: 61
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0f34e7ecfe)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 193, 285)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46f9d50ec4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#904062ca45)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3e06400c7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f9bdb36e62)",
    d: "M 0.441406 0.839844 L 0.441406 216.359375 L 377.566406 216.359375 L 377.566406 0.839844 Z M 0.441406 0.839844 ",
    fillRule: "nonzero"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ececf2",
    d: "M 401.117188 260.636719 C 394.734375 256.996094 386.90625 256.996094 380.527344 260.636719 L 185.957031 371.550781 L 179.371094 372.140625 L 179.371094 381.34375 C 179.371094 381.347656 179.371094 381.351562 179.371094 381.351562 L 179.371094 382.136719 L 179.398438 382.132812 C 179.640625 385.382812 181.378906 388.539062 184.621094 390.382812 L 323.175781 469.367188 C 329.554688 473.007812 337.382812 473.007812 343.765625 469.367188 L 539.671875 357.691406 C 542.957031 355.816406 544.703125 352.597656 544.902344 349.296875 L 544.921875 349.292969 L 544.921875 339.300781 L 539.894531 339.75 C 539.820312 339.707031 539.746094 339.664062 539.671875 339.621094 Z M 401.117188 260.636719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 217.925781 409.375 L 217.925781 353.332031 L 185.957031 371.554688 L 179.371094 372.148438 L 179.371094 382.144531 L 179.398438 382.140625 C 179.640625 385.390625 181.378906 388.542969 184.621094 390.390625 Z M 217.925781 409.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 282.179688 444.964844 L 282.179688 437.113281 L 305.027344 449.964844 L 305.027344 457.816406 Z M 282.179688 444.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#93cf91a111)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 333, 257)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#697a4f39e0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e24d70c70)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 0.585938 215.097656 L 0.585938 30.394531 L 47.527344 3.636719 C 53.90625 -0.00390625 61.734375 -0.00390625 68.117188 3.636719 L 206.671875 82.621094 C 206.746094 82.664062 206.820312 82.707031 206.894531 82.75 L 211.921875 82.300781 L 211.921875 92.292969 L 211.902344 92.296875 C 211.703125 95.597656 209.957031 98.816406 206.671875 100.691406 L 10.765625 212.367188 C 7.609375 214.167969 4.101562 215.078125 0.585938 215.097656 Z M 0.585938 215.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0ab5978974)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 479, 304)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ff116ae0a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#922b96d0df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 0.234375 88.136719 L 0.234375 1.164062 L 60.671875 35.613281 C 60.746094 35.65625 60.820312 35.699219 60.894531 35.746094 L 65.921875 35.292969 L 65.921875 45.289062 L 65.902344 45.289062 C 65.703125 48.59375 63.957031 51.8125 60.671875 53.683594 Z M 0.234375 88.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 186.394531 372.945312 L 180.796875 373.445312 L 180.796875 381.6875 L 180.824219 382.027344 C 181.03125 384.839844 182.527344 387.550781 185.324219 389.144531 L 323.882812 468.128906 C 329.824219 471.515625 337.113281 471.515625 343.058594 468.128906 L 538.964844 356.449219 C 541.800781 354.832031 543.304688 352.066406 543.476562 349.210938 L 543.492188 348.933594 L 543.492188 340.859375 L 539.558594 341.214844 L 539.160156 340.972656 C 539.09375 340.9375 539.03125 340.898438 538.964844 340.859375 L 400.410156 261.875 C 394.464844 258.488281 387.175781 258.488281 381.234375 261.875 Z M 544.921875 339.300781 L 544.921875 349.292969 L 544.902344 349.296875 C 544.703125 352.597656 542.957031 355.816406 539.671875 357.691406 L 343.765625 469.367188 C 337.382812 473.007812 329.554688 473.007812 323.175781 469.367188 L 184.621094 390.382812 C 181.488281 388.601562 179.757812 385.59375 179.429688 382.460938 C 179.417969 382.355469 179.40625 382.246094 179.398438 382.136719 C 179.398438 382.136719 179.398438 382.136719 179.398438 382.132812 L 179.371094 382.136719 L 179.371094 372.140625 L 185.957031 371.550781 L 380.527344 260.636719 C 386.90625 256.996094 394.734375 256.996094 401.117188 260.636719 L 539.671875 339.621094 C 539.746094 339.664062 539.820312 339.707031 539.894531 339.75 Z M 544.921875 339.300781 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ececf2",
    d: "M 380.527344 252.066406 C 386.90625 248.429688 394.734375 248.429688 401.117188 252.066406 L 539.671875 331.050781 C 546.667969 335.042969 546.667969 345.132812 539.671875 349.121094 L 343.765625 460.800781 C 337.382812 464.4375 329.554688 464.4375 323.175781 460.800781 L 184.621094 381.816406 C 177.621094 377.828125 177.621094 367.734375 184.621094 363.746094 Z M 380.527344 252.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 384.152344 264.5 C 389.558594 261.421875 396.195312 261.421875 401.605469 264.5 L 519.050781 331.375 C 524.984375 334.753906 524.984375 343.296875 519.050781 346.675781 L 352.992188 441.226562 C 347.582031 444.308594 340.945312 444.308594 335.539062 441.226562 L 218.089844 374.355469 C 212.15625 370.976562 212.15625 362.433594 218.089844 359.054688 Z M 384.152344 264.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 538.964844 332.292969 L 400.410156 253.308594 C 394.464844 249.921875 387.175781 249.921875 381.234375 253.308594 L 185.324219 364.984375 C 179.289062 368.429688 179.289062 377.132812 185.324219 380.574219 L 323.882812 459.558594 C 329.824219 462.949219 337.113281 462.949219 343.058594 459.558594 L 538.964844 347.882812 C 545 344.441406 545 335.734375 538.964844 332.292969 Z M 401.117188 252.066406 C 394.734375 248.429688 386.90625 248.429688 380.527344 252.066406 L 184.621094 363.746094 C 177.621094 367.734375 177.621094 377.828125 184.621094 381.816406 L 323.175781 460.800781 C 329.554688 464.4375 337.382812 464.4375 343.765625 460.800781 L 539.671875 349.121094 C 546.667969 345.132812 546.667969 335.042969 539.671875 331.050781 Z M 401.117188 252.066406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 332.871094 462.816406 L 334.300781 462.816406 L 334.300781 471.382812 L 332.871094 471.382812 Z M 332.871094 462.816406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 281.46875 436.398438 L 282.894531 436.398438 L 282.894531 444.964844 L 281.46875 444.964844 Z M 281.46875 436.398438 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 304.3125 449.25 L 305.742188 449.25 L 305.742188 457.816406 L 304.3125 457.816406 Z M 304.3125 449.25 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 244.761719 341.324219 C 245.246094 341.050781 245.242188 340.351562 244.757812 340.082031 C 244.539062 339.960938 244.269531 339.960938 244.054688 340.085938 L 204.035156 362.964844 C 197.804688 366.53125 197.804688 375.546875 204.035156 379.109375 L 327.4375 449.667969 C 333.121094 452.917969 340.089844 452.917969 345.773438 449.667969 L 391.398438 423.582031 C 391.878906 423.308594 391.875 422.613281 391.390625 422.339844 C 391.171875 422.21875 390.90625 422.21875 390.6875 422.34375 L 345.066406 448.429688 C 339.820312 451.429688 333.390625 451.429688 328.144531 448.429688 L 204.746094 377.871094 C 199.46875 374.855469 199.46875 367.222656 204.746094 364.207031 Z M 244.761719 341.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ececf2",
    d: "M 514.933594 302.171875 L 514.933594 316.984375 L 512.792969 315.738281 C 512.792969 315.738281 505.605469 320.066406 502.148438 322.066406 C 498.625 324.101562 494.296875 324.101562 490.773438 322.066406 L 412.140625 276.601562 C 410.421875 275.609375 409.472656 273.9375 409.296875 272.199219 L 409.265625 272.1875 L 409.265625 262.90625 C 441.328125 274.820312 479.425781 288.976562 514.933594 302.171875 Z M 514.933594 302.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 427.828125 269.804688 L 427.828125 285.671875 L 412.140625 276.601562 C 410.421875 275.609375 409.472656 273.9375 409.296875 272.199219 L 409.265625 272.1875 L 409.265625 262.90625 Z M 427.828125 269.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c4e917e242)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 494, 294)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#95fca6c7f1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f9ac07a1ee)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 20.933594 22.984375 L 20.933594 8.171875 L 0.941406 0.742188 L 0.941406 29.488281 C 3.394531 29.820312 5.929688 29.34375 8.148438 28.0625 C 11.605469 26.066406 18.792969 21.738281 18.792969 21.738281 Z M 20.933594 22.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2295887ec0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 504, 302)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#28b6ee2132)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b99db02950)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 10.933594 14.984375 L 10.933594 0.171875 L 0.9375 2.964844 L 0.9375 18.023438 C 1.386719 17.75 8.792969 13.738281 8.792969 13.738281 Z M 10.933594 14.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 409.296875 272.199219 C 409.472656 273.9375 410.421875 275.609375 412.140625 276.601562 L 490.773438 322.066406 C 494.296875 324.101562 498.625 324.101562 502.148438 322.066406 C 505.605469 320.066406 512.792969 315.738281 512.792969 315.738281 L 514.933594 316.984375 L 514.933594 302.171875 L 409.265625 262.90625 L 409.265625 272.1875 Z M 410.695312 271.824219 L 410.71875 272.054688 C 410.851562 273.371094 411.5625 274.617188 412.855469 275.367188 L 491.488281 320.828125 C 494.570312 322.609375 498.351562 322.609375 501.433594 320.828125 C 503.152344 319.835938 505.804688 318.257812 508.035156 316.925781 C 509.148438 316.261719 510.152344 315.660156 510.878906 315.222656 C 511.242188 315.003906 511.535156 314.828125 511.742188 314.703125 L 512.054688 314.515625 L 512.792969 315.738281 L 512.054688 314.515625 L 512.78125 314.078125 L 513.503906 314.5 L 513.503906 303.164062 L 410.695312 264.957031 Z M 410.695312 271.824219 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#767cff",
    d: "M 422.101562 252.597656 C 425.617188 250.578125 429.941406 250.578125 433.460938 252.597656 L 512 297.609375 C 515.828125 299.804688 515.828125 305.328125 512 307.523438 L 502.101562 313.195312 C 498.582031 315.210938 494.257812 315.210938 490.738281 313.195312 L 412.199219 268.179688 C 408.371094 265.984375 408.371094 260.464844 412.199219 258.269531 Z M 422.101562 252.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#22e01b5be1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 409, 250)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#957e55583f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb7757ab05)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8de25571e6)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#8a368cd88a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -574,
    fill: "url(#377be7b923)",
    width: 1080,
    height: 1079.999992,
    y: -414.999999
  })))))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 511.347656 299.007812 L 432.714844 253.546875 C 429.632812 251.765625 425.847656 251.765625 422.761719 253.546875 L 412.851562 259.277344 C 409.976562 260.9375 409.976562 265.121094 412.851562 266.78125 L 491.484375 312.246094 C 494.566406 314.027344 498.355469 314.027344 501.4375 312.246094 L 511.347656 306.515625 C 514.222656 304.851562 514.222656 300.671875 511.347656 299.007812 Z M 433.425781 252.296875 C 429.90625 250.257812 425.574219 250.257812 422.050781 252.296875 L 412.140625 258.023438 C 408.308594 260.242188 408.308594 265.820312 412.140625 268.035156 L 490.773438 313.496094 C 494.296875 315.535156 498.625 315.535156 502.148438 313.496094 L 512.058594 307.765625 C 515.890625 305.550781 515.890625 299.972656 512.058594 297.757812 Z M 433.425781 252.296875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 391.476562 302.269531 C 398.089844 298.640625 398.0625 292.792969 391.398438 289.183594 C 384.703125 285.558594 373.855469 285.558594 367.164062 289.183594 C 360.472656 292.808594 360.472656 298.683594 367.164062 302.3125 C 368 302.761719 368.902344 303.160156 369.851562 303.5 C 376.503906 305.878906 385.542969 305.480469 391.398438 302.3125 C 391.421875 302.296875 391.449219 302.28125 391.476562 302.269531 Z M 394.273438 295.746094 C 394.273438 294.476562 393.367188 292.6875 390.375 291.066406 C 387.421875 289.464844 383.410156 288.609375 379.28125 288.609375 C 375.152344 288.609375 371.140625 289.464844 368.183594 291.066406 C 365.195312 292.6875 364.285156 294.476562 364.285156 295.746094 C 364.285156 297.019531 365.195312 298.808594 368.183594 300.425781 C 368.554688 300.628906 368.9375 300.816406 369.339844 300.992188 C 372.144531 302.230469 375.667969 302.886719 379.28125 302.886719 C 379.539062 302.886719 379.796875 302.882812 380.054688 302.878906 C 383.90625 302.777344 387.605469 301.925781 390.375 300.425781 C 390.5625 300.324219 390.742188 300.222656 390.914062 300.121094 C 393.476562 298.585938 394.273438 296.9375 394.273438 295.746094 Z M 394.273438 295.746094 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 410.675781 300.042969 C 409.847656 300.515625 409.84375 301.710938 410.671875 302.1875 L 477.386719 340.5625 C 477.769531 340.78125 478.238281 340.78125 478.617188 340.5625 C 479.441406 340.089844 479.441406 338.898438 478.617188 338.425781 L 411.902344 300.046875 C 411.523438 299.828125 411.054688 299.828125 410.675781 300.042969 Z M 410.675781 300.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 396.011719 310.535156 C 395.183594 310.058594 395.1875 308.863281 396.015625 308.390625 C 396.394531 308.175781 396.863281 308.175781 397.242188 308.394531 L 464.339844 346.992188 C 465.164062 347.464844 465.164062 348.65625 464.339844 349.128906 C 463.957031 349.351562 463.488281 349.351562 463.109375 349.128906 Z M 396.011719 310.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 381.347656 318.882812 C 380.523438 318.40625 380.523438 317.210938 381.355469 316.742188 C 381.734375 316.523438 382.199219 316.523438 382.578125 316.742188 L 416.320312 336.152344 C 417.144531 336.625 417.144531 337.816406 416.320312 338.289062 C 415.9375 338.507812 415.46875 338.507812 415.089844 338.289062 Z M 381.347656 318.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 359.265625 333.605469 C 358.4375 333.128906 358.441406 331.933594 359.269531 331.460938 C 359.652344 331.246094 360.117188 331.246094 360.496094 331.464844 L 427.210938 369.84375 C 428.039062 370.316406 428.039062 371.507812 427.210938 371.980469 C 426.832031 372.199219 426.363281 372.199219 425.980469 371.980469 Z M 359.265625 333.605469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 344.609375 339.808594 C 343.78125 340.28125 343.777344 341.476562 344.605469 341.953125 L 411.703125 380.546875 C 412.082031 380.769531 412.550781 380.769531 412.933594 380.546875 C 413.757812 380.074219 413.757812 378.882812 412.933594 378.410156 L 345.835938 339.8125 C 345.457031 339.59375 344.988281 339.59375 344.609375 339.808594 Z M 344.609375 339.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 329.949219 348.15625 C 329.121094 348.628906 329.117188 349.824219 329.945312 350.300781 L 363.683594 369.707031 C 364.0625 369.925781 364.53125 369.925781 364.914062 369.707031 C 365.738281 369.234375 365.738281 368.042969 364.914062 367.570312 L 331.175781 348.160156 C 330.796875 347.941406 330.328125 347.941406 329.949219 348.15625 Z M 329.949219 348.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 300.722656 369.300781 C 299.894531 368.828125 299.894531 367.632812 300.726562 367.160156 C 301.105469 366.945312 301.570312 366.945312 301.953125 367.164062 L 368.667969 405.539062 C 369.492188 406.015625 369.492188 407.203125 368.667969 407.679688 C 368.285156 407.898438 367.816406 407.898438 367.4375 407.679688 Z M 300.722656 369.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 286.066406 375.507812 C 285.234375 375.980469 285.234375 377.175781 286.058594 377.648438 L 353.15625 416.246094 C 353.539062 416.464844 354.007812 416.464844 354.386719 416.246094 C 355.214844 415.773438 355.214844 414.582031 354.386719 414.109375 L 287.289062 375.511719 C 286.910156 375.292969 286.445312 375.292969 286.066406 375.507812 Z M 286.066406 375.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 271.402344 383.855469 C 270.574219 384.328125 270.570312 385.523438 271.398438 385.996094 L 305.136719 405.40625 C 305.519531 405.625 305.988281 405.625 306.367188 405.40625 C 307.195312 404.929688 307.195312 403.742188 306.367188 403.265625 L 272.628906 383.859375 C 272.25 383.640625 271.785156 383.640625 271.402344 383.855469 Z M 271.402344 383.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#767cff",
    d: "M 313.15625 321.304688 L 312.179688 330.503906 C 311.984375 332.3125 314.453125 333.78125 317.3125 333.566406 L 347.894531 331.261719 C 349.507812 331.136719 350.722656 330.277344 350.722656 329.257812 C 350.722656 328.105469 349.179688 327.183594 347.34375 327.246094 L 321.148438 328.113281 L 319.929688 321.210938 C 319.738281 320.128906 318.28125 319.308594 316.546875 319.308594 C 314.757812 319.308594 313.273438 320.179688 313.15625 321.304688 Z M 253.179688 357 L 252.203125 366.203125 C 252.011719 368.007812 254.480469 369.480469 257.339844 369.265625 L 287.921875 366.957031 C 289.535156 366.835938 290.75 365.976562 290.75 364.957031 C 290.75 363.800781 289.207031 362.882812 287.371094 362.945312 L 261.175781 363.808594 L 259.953125 356.90625 C 259.761719 355.824219 258.308594 355.007812 256.574219 355.007812 C 254.785156 355.007812 253.300781 355.878906 253.179688 357 Z M 253.179688 357 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ececf2",
    d: "M 482.351562 406.097656 C 512.464844 389.835938 512.464844 363.472656 482.351562 347.210938 C 452.242188 330.949219 403.417969 330.949219 373.304688 347.210938 C 343.195312 363.472656 343.195312 389.835938 373.304688 406.097656 C 403.417969 422.359375 452.242188 422.359375 482.351562 406.097656 Z M 472.175781 398.828125 C 496.667969 386.582031 496.667969 366.726562 472.175781 354.480469 C 447.683594 342.234375 407.976562 342.234375 383.484375 354.480469 C 358.992188 366.726562 358.992188 386.582031 383.484375 398.828125 C 407.976562 411.074219 447.683594 411.074219 472.175781 398.828125 Z M 472.175781 398.828125 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 503.511719 376.652344 C 503.511719 366.738281 496.496094 356.46875 481.675781 348.46875 C 466.878906 340.476562 447.394531 336.441406 427.828125 336.441406 C 408.265625 336.441406 388.78125 340.476562 373.984375 348.46875 C 359.164062 356.46875 352.148438 366.738281 352.148438 376.652344 C 352.148438 386.570312 359.164062 396.835938 373.984375 404.839844 C 388.78125 412.828125 408.265625 416.863281 427.828125 416.863281 C 447.394531 416.863281 466.878906 412.828125 481.675781 404.839844 C 496.496094 396.835938 503.511719 386.570312 503.511719 376.652344 Z M 491.972656 376.652344 C 491.972656 385.476562 485.261719 393.878906 472.816406 400.105469 C 460.320312 406.351562 444.035156 409.4375 427.828125 409.4375 C 411.625 409.4375 395.339844 406.351562 382.84375 400.105469 C 370.398438 393.878906 363.6875 385.476562 363.6875 376.652344 C 363.6875 367.832031 370.398438 359.425781 382.84375 353.203125 C 395.339844 346.957031 411.625 343.867188 427.828125 343.867188 C 444.035156 343.867188 460.320312 346.957031 472.816406 353.203125 C 485.261719 359.425781 491.972656 367.832031 491.972656 376.652344 Z M 482.351562 347.210938 C 512.464844 363.472656 512.464844 389.835938 482.351562 406.097656 C 452.242188 422.359375 403.417969 422.359375 373.304688 406.097656 C 343.195312 389.835938 343.195312 363.472656 373.304688 347.210938 C 403.417969 330.949219 452.242188 330.949219 482.351562 347.210938 Z M 472.175781 354.480469 C 496.667969 366.726562 496.667969 386.582031 472.175781 398.828125 C 447.683594 411.074219 407.976562 411.074219 383.484375 398.828125 C 358.992188 386.582031 358.992188 366.726562 383.484375 354.480469 C 407.976562 342.234375 447.683594 342.234375 472.175781 354.480469 Z M 472.175781 354.480469 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 503.839844 369.628906 C 501.25 361.417969 494.089844 353.546875 482.351562 347.210938 C 452.242188 330.949219 403.417969 330.949219 373.304688 347.210938 C 361.570312 353.546875 354.410156 361.417969 351.820312 369.628906 L 366.699219 369.628906 C 369.242188 364.078125 374.835938 358.804688 383.484375 354.480469 C 407.976562 342.234375 447.683594 342.234375 472.175781 354.480469 C 480.824219 358.804688 486.417969 364.078125 488.957031 369.628906 Z M 503.839844 369.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#767cff",
    d: "M 482.351562 397.527344 C 512.464844 381.269531 512.464844 354.902344 482.351562 338.644531 C 452.242188 322.382812 403.417969 322.382812 373.304688 338.644531 C 343.195312 354.902344 343.195312 381.269531 373.304688 397.527344 C 403.417969 413.789062 452.242188 413.789062 482.351562 397.527344 Z M 472.175781 390.257812 C 496.667969 378.011719 496.667969 358.160156 472.175781 345.914062 C 447.683594 333.667969 407.976562 333.667969 383.484375 345.914062 C 358.992188 358.160156 358.992188 378.011719 383.484375 390.257812 C 407.976562 402.503906 447.683594 402.503906 472.175781 390.257812 Z M 472.175781 390.257812 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e4b02946d9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 350, 325)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0dc0605888)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52ff159287)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2009808e47)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#a715dc7002)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -515,
    fill: "url(#6e8bb29258)",
    width: 1080,
    height: 1079.999992,
    y: -489.999999
  })))))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 503.511719 368.085938 C 503.511719 358.167969 496.496094 347.902344 481.675781 339.898438 C 466.878906 331.910156 447.394531 327.875 427.828125 327.875 C 408.265625 327.875 388.78125 331.910156 373.984375 339.898438 C 359.164062 347.902344 352.148438 358.167969 352.148438 368.085938 C 352.148438 378.003906 359.164062 388.269531 373.984375 396.273438 C 388.78125 404.261719 408.265625 408.296875 427.828125 408.296875 C 447.394531 408.296875 466.878906 404.261719 481.675781 396.273438 C 496.496094 388.269531 503.511719 378.003906 503.511719 368.085938 Z M 491.972656 368.085938 C 491.972656 376.90625 485.261719 385.3125 472.816406 391.535156 C 460.320312 397.785156 444.035156 400.871094 427.828125 400.871094 C 411.625 400.871094 395.339844 397.785156 382.84375 391.535156 C 370.398438 385.3125 363.6875 376.90625 363.6875 368.085938 C 363.6875 359.265625 370.398438 350.859375 382.84375 344.636719 C 395.339844 338.386719 411.625 335.300781 427.828125 335.300781 C 444.035156 335.300781 460.320312 338.386719 472.816406 344.636719 C 485.261719 350.859375 491.972656 359.265625 491.972656 368.085938 Z M 482.351562 338.644531 C 512.464844 354.902344 512.464844 381.269531 482.351562 397.527344 C 452.242188 413.789062 403.417969 413.789062 373.304688 397.527344 C 343.195312 381.269531 343.195312 354.902344 373.304688 338.644531 C 403.417969 322.382812 452.242188 322.382812 482.351562 338.644531 Z M 472.175781 345.914062 C 496.667969 358.160156 496.667969 378.011719 472.175781 390.257812 C 447.683594 402.503906 407.976562 402.503906 383.484375 390.257812 C 358.992188 378.011719 358.992188 358.160156 383.484375 345.914062 C 407.976562 333.667969 447.683594 333.667969 472.175781 345.914062 Z M 472.175781 345.914062 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ececf2",
    d: "M 492.144531 391.453125 C 490.855469 390.386719 488.738281 390.421875 486.347656 391.804688 C 482.417969 394.066406 479.234375 399.089844 479.234375 403.015625 C 479.234375 405.117188 480.144531 406.480469 481.59375 406.945312 L 557.769531 450.675781 L 569.195312 435.683594 Z M 492.144531 391.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#7c16a05e9b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 479, 390)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5692a8aa6b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1444e7b7f8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 13.144531 1.453125 C 11.855469 0.386719 9.738281 0.421875 7.347656 1.804688 C 3.417969 4.066406 0.234375 9.089844 0.234375 13.015625 C 0.234375 15.117188 1.144531 16.480469 2.59375 16.945312 L 78.769531 60.675781 L 90.195312 45.683594 Z M 13.144531 1.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 491.328125 392.628906 L 491.234375 392.550781 C 490.621094 392.042969 489.230469 391.789062 487.058594 393.039062 C 485.332031 394.039062 483.710938 395.679688 482.523438 397.550781 C 481.332031 399.433594 480.664062 401.40625 480.664062 403.015625 C 480.664062 404.683594 481.335938 405.363281 482.03125 405.585938 L 482.175781 405.632812 L 557.394531 448.816406 L 567.070312 436.113281 Z M 569.195312 435.683594 L 557.769531 450.675781 L 481.59375 406.945312 C 480.144531 406.480469 479.234375 405.117188 479.234375 403.015625 C 479.234375 399.089844 482.417969 394.066406 486.347656 391.804688 C 488.738281 390.421875 490.855469 390.386719 492.144531 391.453125 Z M 569.195312 435.683594 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 563.457031 450.292969 C 567.382812 448.027344 570.566406 443.007812 570.566406 439.082031 C 570.566406 435.152344 567.382812 433.804688 563.457031 436.070312 C 559.527344 438.335938 556.34375 443.355469 556.34375 447.28125 C 556.34375 451.210938 559.527344 452.558594 563.457031 450.292969 Z M 563.457031 450.292969 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 567.277344 444.546875 C 568.472656 442.664062 569.136719 440.691406 569.136719 439.082031 C 569.136719 437.507812 568.539062 436.824219 567.929688 436.566406 C 567.214844 436.265625 565.929688 436.292969 564.167969 437.304688 C 562.4375 438.304688 560.820312 439.945312 559.632812 441.816406 C 558.4375 443.699219 557.773438 445.671875 557.773438 447.28125 C 557.773438 448.851562 558.375 449.535156 558.984375 449.792969 C 559.695312 450.097656 560.984375 450.070312 562.742188 449.054688 C 564.472656 448.058594 566.089844 446.414062 567.277344 444.546875 Z M 570.566406 439.082031 C 570.566406 443.007812 567.382812 448.027344 563.457031 450.292969 C 559.527344 452.558594 556.34375 451.210938 556.34375 447.28125 C 556.34375 443.355469 559.527344 438.335938 563.457031 436.070312 C 567.382812 433.804688 570.566406 435.152344 570.566406 439.082031 Z M 570.566406 439.082031 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupInfo);
export default __webpack_public_path__ + "static/media/popup-info.4b52f2f09d696eaf88468c6846af6149.svg";
export { ForwardRef as ReactComponent };